import { ArrowExpandIcon } from '@calendly/ui/components/icons';
import { Link } from '@calendly/ui/components/link';
import classNames from 'classnames';
import { forwardRef } from 'react';
const containerCss = "c1fl4gzc";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const styledLinkCss = "s1k3z9r5";
const StyledLink = forwardRef((props, ref) => <Link ref={ref} {...props} className={classNames(styledLinkCss, props.className)} />);
export const EventTypeList = ({
  eventTypes
}) => <Container>
    {eventTypes.map(({
    id,
    name,
    edit_path: editPath
  }) => <StyledLink underline={false} key={id} href={editPath} target="_blank" rel="opener">
          <ArrowExpandIcon inline size="large" />
          {name}
        </StyledLink>)}
  </Container>;

require("./event_type_list.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./event_type_list.js");